import { jsx as _jsx } from "react/jsx-runtime";
import { GuardedNodeComponent } from '../../components/GuardedNodeComponent.js';
import { useCanvasWorkspace } from '../../contexts/CanvasWorkspaceContext.js';
import { drawsInWorkspace } from '../../nodeWorkspaceVisibility.js';
/** `node` is the synthesised `GLBSceneRoot` of the instanced `.glb`. */
export function GlbRootNode({ node }) {
    const workspace = useCanvasWorkspace();
    if (!drawsInWorkspace(node.type, workspace))
        return null;
    return _jsx(GuardedNodeComponent, { node: node });
}
//# sourceMappingURL=GlbRootNode.js.map